<template>
  <div id="engine-card-builder">
    <div class="orbitist-modal">
      <div class="orbitist-modal-container">
        <div class="orbitist-modal-header">
          <a @click="closeCardBuilder()" title="Close" class="close clickable"><i class="far fa-times"></i></a>
          <p class="lead">Card Builder</p>
        </div><!-- /.orbitist-modal-header -->

        <div class="orbitist-modal-content">
            <div class="orbitist-modal-options">

              <!-- CARD FORM -->
              <form class="mt-4 pl-4" @submit.prevent>
                <!-- NAME -->
                <div class="form-group">
                  <label>Name</label>
                  <input v-model="card.name" class="form-control" placeholder="Card Name" />
                </div><!-- /.form-group -->
                <!-- CHARARACTER UPLOAD -->
                <div class="form-group">
                  <label>Character Art</label>
                  <CharacterUpload v-on:mediaDelivery="mediaDelivery($event)" :media="card.characterArt" />
                </div><!-- /.form-group -->
                <!-- VALUE -->
                <div class="form-group">
                  <label>Value</label>
                  <input v-model.number="card.value" type="number" class="form-control" placeholder="Card Value" />
                </div><!-- /.form-group -->
                <!-- FLAVOR TEXT -->
                <div class="form-group">
                  <label>Flavor Text</label>
                  <textarea v-model="card.flavorText" class="form-control" placeholder="An epic tale about this card..." />
                </div><!-- /.form-group -->
                <!-- SUIT -->
                <div class="form-group">
                  <label>Suit</label>
                  <multiselect v-model="card.suit" :options="suits" label="name"></multiselect>
                </div><!-- /.form-group -->
                <!-- CURSE TYPE -->
                <div class="form-group">
                  <label>Curse Type</label>
                  <multiselect v-model="card.curseType" :options="curseTypes" label="name"></multiselect>
                </div><!-- /.form-group -->
                <!-- ELEMENT -->
                <div class="form-group">
                  <label>Element</label>
                  <multiselect v-model="card.element" :options="elements" label="name"></multiselect>
                </div><!-- /.form-group -->
                <!-- TAGS -->
                <div class="form-group">
                  <label>Tags</label>
                  <multiselect v-model="card.tags" :options="tags" :multiple="true" label="name"></multiselect>
                </div><!-- /.form-group -->
              </form>

            </div><!-- orbitist-modal-options -->
            <div class="orbitist-modal-preview">

              <!-- CARD PREVIEW -->
              <div class="card-normal">
                <div v-if="card.characterArt" class="card-character-art">
                  <img :src="card.characterArt.url" class="img-fluid"/>
                </div>
                <div v-if="card.value" class="card-normal-value">
                  {{ card.value }}
                </div>
                <div v-if="card.name" class="card-normal-title">
                  {{ card.name }}
                </div>
                <div v-if="card.flavorText" class="card-normal-flavor-text">
                  {{ card.flavorText }}
                </div>
                <div v-if="card.suit" class="card-normal-suit">
                  {{ card.suit.name }}
                </div>
                <div v-if="card.curseType" class="card-normal-curse-type">
                  {{ card.curseType.name }}
                </div>
              </div>

            </div><!-- /.orbitist-modal-preview -->
        </div><!-- /.orbitist-modal-content -->

        <div class="orbitist-modal-footer">
          <button v-if="editMode == false" @click="createCard()" v-b-tooltip.hover title="Create Card" class="btn btn-outline-secondary float-right"><i class="fal fa-file-plus"></i></button>
          <button v-if="editMode == true" @click="deleteCard()" v-b-tooltip.hover title="Delete Card" class="btn btn-outline-danger float-right ml-2"><i class="fal fa-trash"></i></button>
          <button v-if="editMode == true" @click="saveCard()" v-b-tooltip.hover title="Save Card" class="btn btn-outline-secondary float-right"><i class="fal fa-save"></i></button>
        </div><!-- /.orbitist-modal-footer -->
      </div><!-- /.orbitist-modal-content -->
    </div><!-- /.orbitist-modal -->
  </div><!-- /#engine-card-builder -->
</template>

<script>
const fb = require('../../firebaseConfig.js')
import Multiselect from 'vue-multiselect'
import CharacterUpload from './uploaders/CharacterUpload.vue'

export default {
  data() {
    return {
      card: {
        characterArt: {}
      },
      editMode: false,
      suits: [
        {name: 'Ashlands'},
        {name: 'Hollows'},
        {name: 'Mountains'},
        {name: 'Swamps'},
        {name: 'Hearts'},
        {name: 'Spades'},
        {name: 'Clubs'},
        {name: 'Diamonds'}
      ],
      curseTypes: [
        {name: 'Demon'},
        {name: 'Ghost'},
        {name: 'Item'},
        {name: 'Disease'},
        {name: 'Affliction'},
        {name: 'Beast'},
        {name: 'Undead'},
        {name: 'Fungal'},
        {name: 'Vegetative'},
        {name: 'Cult'},
        {name: 'Queen'},
        {name: 'King'}
      ],
      elements: [
        {name: 'Fire'},
        {name: 'Earth'},
        {name: 'Air'},
        {name: 'Water'}
      ],
      tags: [
        {name: 'Traditional'}
      ]
    }
  },
  props: [ 'cardId' ],
  components: { Multiselect, CharacterUpload },
  created() {
    if (this.cardId) {
      console.log('In edit mode!')
      this.editMode = true
      fb.cardsCollection.doc(this.cardId).onSnapshot(card => {
        this.card = card.data()
      })
    }
  },
  methods: {
    mediaDelivery(art) {
      this.card.characterArt = art
    },
    deleteCard() {
      let check = confirm("DANGER! Are you sure you want to delete this deck? This cannot be undone!")
      if (check == true) {
        let self = this
        fb.cardsCollection.doc(this.cardId).delete().then(function() {
          alert('Card deleted!')
          self.closeCardBuilder()
        })
      } else { return false }
    },
    createCard() {
      this.card.createdOn = new Date()
      this.card.updatedOn = new Date()
      let self = this
      fb.cardsCollection.add(this.card).then(function() {
        alert('Card Created!')
        self.closeCardBuilder()
      })
    },
    saveCard() {
      this.card.updatedOn = new Date()
      fb.cardsCollection.doc(this.cardId).update(this.card).then(function() {
        alert('Card Saved!')
      })
    },
    closeCardBuilder() {
      this.$emit('closeCardBuilder')
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/engine/EngineCardBuilder.vue